import { createRouter, createWebHistory } from "vue-router";
import Login from "./components/Login.vue";
import Analyzer from "./components/AnalyzerX.vue";
import Parameters from "./components/Parameters.vue";
import PrescientSL from "./components/PrescientSL.vue";
import Martingale from "./components/Martingale.vue";
import Dashboard from "./components/Dashboard.vue";
import Factory from "./components/Factory.vue";

const routes = [
    { path: "/login", component: Login },
    { path: "/", redirect: "/dashboard" }, // ✅ Redirige vers Indicators par défaut
    { path: "/analyzer", component: Analyzer, meta: { requiresAuth: true } },
    { path: "/parameters", component: Parameters, meta: { requiresAuth: true } },
    { path: "/prescientsl", component: PrescientSL, meta: { requiresAuth: true } },
    { path: "/martingale", component: Martingale, meta: { requiresAuth: true } },
    { path: "/factory", component: Factory, meta: { requiresAuth: true } },
    { path: "/dashboard", component: Dashboard, meta: { requiresAuth: true } },
    { path: "/:catchAll(.*)", redirect: "/login" } // ✅ Redirige les pages inconnues vers login
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

// ✅ Protection des routes : redirige vers /login si non authentifié
router.beforeEach((to, from, next) => {
    const isAuthenticated = localStorage.getItem("isAuthenticated") === "true"; // ✅ Convertit en booléen

    if (to.meta.requiresAuth && !isAuthenticated) {
        console.warn("🔒 Accès refusé, redirection vers login...");
        next("/login");
    } else {
        next(); // ✅ Navigation OK
    }
});


export default router;
